import { ReactNode } from "react";
import { StackProps, DividerProps, TypographyProps, Stack, Divider, Typography } from "@mui/material";

export interface StatusBoxProps {
    title: ReactNode;
    value: ReactNode;
}

function StatusBox(props: StatusBoxProps) {
    const stackProps: StackProps = {
        sx: {
            gap: 2,
            flex: 1,
        },
    };

    const dividerProps: DividerProps = {
        sx: {
            borderWidth: "2px",
            borderRadius: "30px",
            borderColor: "#E0E3E7",
        },
    };

    const textStackProps: StackProps = {
        sx: {
            alignItems: "center",
        },
    };

    const titleProps: TypographyProps = {
        sx: {
            fontSize: 14,
            fontWeight: 500,
            color: "#7C8593",
        },
        children: props.title,
    };

    const valueProps: TypographyProps = {
        sx: {
            fontSize: 14,
            fontWeight: 500,
            color: "#737A86",
        },
        children: props.value,
    };

    return (
        <Stack {...stackProps}>
            <Divider {...dividerProps} />
            <Stack {...textStackProps}>
                <Typography {...titleProps} />
                <Typography {...valueProps} />
            </Stack>
        </Stack>
    );
}

export default StatusBox;
